import { completePilar } from '@api/actionPlan';

export const handleCompletePilarEmail = async (activeSubNavId: number, planId: number | null) => {
  const payload = {
    questionnaireId: activeSubNavId ?? null,
    improvePlanId: planId,
  };
  await completePilar(payload);
};
